import urlBase from 'EstruturaAntiga/assets/urlsBase';
import * as HttpRequest from 'EstruturaAntiga/assets/httpRequest';
import axios from 'axios';
import { authContextInstance } from 'context/AuthContext';
class BaseService{
    constructor(baseURL){
        this.baseURL = baseURL || urlBase.urlBase;
    }
    async request(endpoint, method = "GET", data = null, customHeader = null, authenticated = true, { ignorarLogoutEm401 = false } = {}){
        let url = `${this.baseURL}/${endpoint}`;
        let options = {
            headers:{
                'Content-Type': "application/json"
            },
            method
        };
        if (authenticated){
            const {Accept, Authorization} = await HttpRequest.axiosApiTokenHeader();
            options.headers.Accept = Accept;
            options.headers.Authorization = Authorization;

            if(customHeader){
                options.headers = {
                    Authorization: Authorization,
                    ...customHeader
                }
            }
        }

        if(data){
            options.data = data;
        }
        return axios(url, options).then(response => {
            if(response.status >= 200 && response.status < 300){
                return response.data;
            }
            if(response.status == 401 && !ignorarLogoutEm401){
                authContextInstance.forceLogout();
            }
            return Promise.reject(response);
        }).catch(error =>{
            console.error("Houve um problema com a solicitação:", error)
            if(error.request.status == 401 && !ignorarLogoutEm401){
                authContextInstance.forceLogout();
                return null;
            }
            throw error;
        });
    }
    async get(endpoint, authenticated = true, { ignorarLogoutEm401 = false } = {}){
        const method = "GET"
        return await this.request(endpoint, method, null, null, authenticated, { ignorarLogoutEm401 })
    }
    post(endpoint, data, authenticated = true, formData = false){
        const method = "POST"
        if (formData) {
            const headers = {
                "Content-Type": "multipart/form-data",
            }
            return this.request(endpoint, method, data, headers, authenticated)
        }
        return this.request(endpoint, method, data, null, authenticated)
    }
    delete(endpoint,data){
        const method = "DELETE"
        return this.request(endpoint, method, data, {})
    }
    put(endpoint, data, authenticated = true){
        const method = "PUT"
        return this.request(endpoint, method, data, null, authenticated)
    }
    patch(endpoint, data, { ignorarLogoutEm401 = false } = {}){
        const method = "PATCH"
        return this.request(endpoint, method, data, null, true, { ignorarLogoutEm401 })
    }
}
export default BaseService;